import { IPersonaProps, IPersonaSharedProps, Persona, PersonaInitialsColor, PersonaSize } from '@fluentui/react';

export interface IUserInfoDisplayProps {
    displayName?: string;
    displayInitials?: string;
    secondaryText?: string;
    initialsOrImageOnly?: boolean;
    dataTestId?: string;
}

export function UserInfoDisplay(props: IUserInfoDisplayProps) {
    const personaWithInitials: IPersonaSharedProps = {
        secondaryText: props.secondaryText,
        text: props.displayName,
        imageInitials: props.displayInitials,
    };

    const personaStyles = {
        root: {
            margin: 5,
        },
    };

    const handleRenderPrimaryText = (personaProps?: IPersonaProps) => {
        if (!personaProps) {
            return null;
        }
        return <div data-testid={props.dataTestId}>{personaProps.text}</div>;
    };

    return (
        <Persona
            {...personaWithInitials}
            styles={personaStyles}
            initialsColor={PersonaInitialsColor.coolGray}
            size={PersonaSize.size32}
            hidePersonaDetails={props.initialsOrImageOnly}
            onRenderPrimaryText={handleRenderPrimaryText}
            showOverflowTooltip={false}
        />
    );
}
